export const TEST_ID = 'detailsView';
